import { useEffect } from 'react';
import { useAuth } from '../context/auth.context';
import { useUser } from '../context/user.context';
import LoginLoader from './login-loader.component';

const LogoutCallback = () => {
  const { state } = useUser();
  const { signoutRedirectCallback } = useAuth();

  useEffect(() => {
    signoutRedirectCallback(state?.isDefaultIdp);
  });

  return <LoginLoader title="Redirecting to login" />;
};
export default LogoutCallback;
